<template>
    <div class="page">
        <div class="page__bd">
            <article class="weui-article">
                <section>
                    <section>
                        <p>
                            <img src="../../assets/qujian-tips-1.jpg" alt="">
                            <img src="../../assets/qujian-tips-2.jpg" alt="">
                            <img src="../../assets/qujian-tips-3.jpg" alt="">
                        </p>
                    </section>
                </section>
            </article>
        </div>
        <div class="weui-footer">
            <p class="weui-footer__links">
                <a href="javascript:void(0);" class="weui-footer__link">校圆通</a>
            </p>
            <p class="weui-footer__text">Copyright &copy; 2017-{{year}} aixyt.com</p>
        </div>
    </div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
        year: moment().format('YYYY')
    };
  }
};
</script>

<style scoped>
.weui-footer {
  margin-bottom: 20px;
  left: 0px;
  right: 0px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
</style>




// WEBPACK FOOTER //
// src/components/infos/QujianTips.vue